export const addJs = (url, fileName) => {
  return new Promise(function (resolve, reject) {
    if (alreadyLoaded(fileName)) {
      return resolve(url);
    }
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.setAttribute('data-adv-name', fileName);
    script.onload = function () {
      resolve(url);
    };
    script.onerror = function () {
      reject(url);
    };
    document.body.appendChild(script);
  });
};

export const addCss = (url, fileName) => {
  return new Promise(function (resolve, reject) {
    if (alreadyLoaded(fileName)) {
      return resolve(url);
    }
    let head = document.head;
    let link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', url);
    link.setAttribute('data-adv-name', fileName);
    link.onload = function () {
      resolve(url);
    };
    link.onerror = function () {
      reject(url);
    };
    head.prepend(link);
  });
};

const alreadyLoaded = (fileName) => {
  return document.querySelector(`*[data-adv-name=${fileName}]`);
};
